import { GigaUserApi } from "@giga-user-fern/api";
import { GuideData } from "@giga-user-fern/api/types/api/resources/guides";
import { VideoEdits } from "@giga-user-fern/api/types/api/resources/video";
import { HelpCenterProps } from "@gigauser/common/src/help-center/HelpCenter/HelpCenter";
import { helpSaver } from "@gigauser/common/src/network/helpcenterSaver";
import React from "react";

type ExtHelpCenterContextValue = HelpCenterProps;

const ExtHelpCenterContext = React.createContext<ExtHelpCenterContextValue>({
	navigator: () => (a: string) => {},
	environment: "ext-hc",

	search: helpSaver.search,

	getOrganization: () => {
		return helpSaver.organization;
	},

	fetchAllGuidePreviews: async () => {
		const guidePreviews = await helpSaver.fetchAllGuidePreviews();
		return guidePreviews;
	},

	fetchAllChildren: async (collectionId?: string) => {
		const { guides, collections } = await helpSaver.fetchAllChildren(
			collectionId,
			true,
		);
		return Promise.resolve({
			collections: collections,
			guidePreviews: guides,
		});
	},

	fetchGuidePreview: async (id: GigaUserApi.Id) => {
		const guidePreview = await helpSaver.fetchGuidePreview(id);
		return guidePreview;
	},

	getPath: async (id: string) => {
		const path = await helpSaver.getPath(id);
		return path;
	},

	fetchGuideData: async (id: GigaUserApi.Id) => {
		const guideData = (await helpSaver.fetchGuideData(id)) as GuideData;
		return guideData;
	},

	close: () => {},

	helpCenterSessionId: "",
});

export default ExtHelpCenterContext;
